<div class="aems-card m-b-12">
  @if (sortedWorkOrderRemark.length > 0) {
    <div class="remark-list m-b-12">
      @for (remark of sortedWorkOrderRemark; track $index) {
        <div class="remark-row">
          @if (!user.isExternal && remark.maintenanceOrderRemarkType === 'S') {
            <span class="remark-type">
              <mc-icon class="remark-icon" icon="computer"></mc-icon>
            </span>
          }
          @if (!user.isExternal && remark.maintenanceOrderRemarkType === 'E') {
            <span class="remark-type">
              <mc-icon class="remark-icon" icon="arrow-all-directions"></mc-icon>
            </span>
          }
          @if (!user.isExternal && remark.maintenanceOrderRemarkType === 'I' && remark.maintenanceOrderRemarkScope == 0) {
            <span class="remark-type">
              <mc-icon class="remark-icon" icon="info-circle"></mc-icon>
            </span>
          }
          @if (!user.isExternal && remark.maintenanceOrderRemarkType === 'I' && remark.maintenanceOrderRemarkScope == 1) {
            <span class="remark-type">
              <mc-icon class="remark-icon" icon="arrow-all-directions"></mc-icon>
            </span>
          }
          <span [ngClass]="{ 'remark-user': !user.isExternal }">{{ remark.createUserId }}</span>
          <span class="remark-time"> {{ remark.createTimestamp | date: 'yyyy-MM-dd HH:mm' }}</span>
        </div>
        <div class="m-b-4 m-l-24">
          <span class="remark-text --mds_brand_appearance_neutral_weakest_text-color">{{ remark.maintenanceOrderRemarkText }}</span>
        </div>
      }
    </div>
  }
  <form [formGroup]="remarkForm" (ngSubmit)="onSaveRemark()">
    <mc-textarea
      label="Remarks"
      hiddenlabel
      ngDefaultControl
      maxlength="255"
      placeholder="Please indicate general condition of box, main damage consists, wear and team share of repair, repair in other mode required."
      rows="3"
      fit="small"
      formControlName="remark">
    </mc-textarea>
    @if (showPredefinedRemarks) {
      <div class="pre-decided-remark-container">
        @for (remark of predefinedRemarkFilteredByRepairMode(); track $index) {
          <mc-tag (click)="predefinedRemarkTagClicked(remark.comment)" [label]="remark.comment"></mc-tag>
        }
      </div>
    }
    @if (!user.isExternal && !authPolicy.isProcurementOnly) {
      <mc-checkbox
        fit="small"
        formControlName="saveAsExternal"
        label="Mark this as external"
        [checked]="remarkForm.controls.saveAsExternal.value"
        (change)="onCheckChange($event)"
        ngDefaultControl>
      </mc-checkbox>
    }

    @if (!authPolicy.isProcurementOnly) {
      <mc-button
        label="Save Remark"
        variant="outlined"
        appearance="primary"
        fit="small"
        padding="default"
        class="m-t-16"
        type="submit"
        [loading]="postingRemark()"
        [disable]="this.remarkForm.valid"
        [hidden]="workOrderMode === 'create'"></mc-button>
    }
  </form>
</div>
